// imagenes
import resto from '../../assets/images/experience/resto.jpg'
import restox2 from '../../assets/images/experience/restox2.jpg'
import popUp from '../../assets/images/experience/pop_up.jpg'
import popUpx2 from '../../assets/images/experience/pop_upx2.jpg'
import event from '../../assets/images/experience/event.jpg'
import eventx2 from '../../assets/images/experience/eventx2.jpg'
import consult from '../../assets/images/experience/consult.jpg'
import consultx2 from '../../assets/images/experience/consultx2.jpg'
import { Trans } from 'react-i18next'

const Experience = () => {
  return (
    <section className="experience">
      <div className="container">
        <div className="exp-title">
          <h4>
            <Trans i18nKey="experience.title" />
          </h4>
        </div>

        <div className="row justify-content-center">
          <div className="col-12 col-md-10">
            <div className="row">
              <div className="col-12 col-sm-6">
                {/* Diferentes experiencias */}
                <div className="exp" data-aos="fade">
                  <img src={resto} alt="Menu" srcSet={restox2 + ' 2x'}></img>
                  <p className="titulo-exp">
                    <Trans i18nKey="experience.cards.restaurante.title" />
                  </p>
                  <p>
                    <Trans i18nKey="experience.cards.restaurante.description" />
                  </p>
                </div>
              </div>
              <div className="col-12 col-sm-6">
                <div className="exp" data-aos="fade">
                  <img src={popUp} alt="pop-up" srcSet={popUpx2 + ' 2x'}></img>
                  <p className="titulo-exp">
                    <Trans i18nKey="experience.cards.popUp.title" />
                  </p>
                  <p>
                    <Trans i18nKey="experience.cards.popUp.description" />
                  </p>
                </div>
              </div>
              <div className="col-12 col-sm-6">
                <div className="exp" data-aos="fade">
                  <img src={event} alt="eventos" srcSet={eventx2 + ' 2x'}></img>
                  <p className="titulo-exp">
                    <Trans i18nKey="experience.cards.eventos.title" />
                  </p>
                  <p>
                    <Trans i18nKey="experience.cards.eventos.description" />
                  </p>
                </div>
              </div>
              <div className="col-12 col-sm-6">
                <div className="exp" data-aos="fade">
                  <img src={consult} alt="consultoría" srcSet={consultx2 + ' 2x'}></img>
                  <p className="titulo-exp">
                    <Trans i18nKey="experience.cards.consultoria.title" />
                  </p>
                  <p>
                    <Trans i18nKey="experience.cards.consultoria.description" />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Experience
